var $ = require('jquery');
require('jquery-placeholder');

var self = {};

self.initialise = function($placeholderLabels) {
  var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();

  function setPlaceHolders() {
    //On page load, set placeholders for hidden labels
    self.initialise($('label.sr-only'));
  }

  pageRequestManager.add_endRequest(setPlaceHolders);

  $(document).ready(function() {
    if ($placeholderLabels.length) {
      //adds label content as placeholder to inputs
      $placeholderLabels.each(function() {
        var $this = $(this);

        var name = $this.attr('for');

        var $input = $('#' + name);
        $input.attr('placeholder', $this.html());
        $input.placeholder({ customClass: 'placeholder-input' });
      });
    }
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/placeholder.js